"use client";

import React from "react";
import Link from "next/link";
import { Container } from "react-bootstrap";
import styles from "./MakeWebsiteLiveSection.module.css";

const MakeWebsiteLiveSection: React.FC = () => {
  return (
    <section className={styles.heroSection}>
      <Container className="text-center">
        <h1 className={styles.title}>Make Your Website Live!</h1>
        <p className={styles.subtitle}>
          Choose Your Desired Web Hosting Plan Now
        </p>
        <div className="d-flex justify-content-center">
          <Link
            href="https://www.temok.com/linux-shared-hosting-usa"
            className={styles.ctaButton}
          >
            Claim Your Free Domain &amp; Hosting Today!
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default MakeWebsiteLiveSection;
